import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, catchError, throwError, map } from 'rxjs';
import { Modelogeneral } from '../models/modelogeneral'
import { Modelogeneraldatos } from '../models/modelogeneraldatos'
import { Login } from '../models/login'
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})

export class JavapiService {

  appId: string = 'pgarcia';

  constructor(private http: HttpClient) { }

  genericPost(endpoint: string, data: any): Observable<any> {
    const url = `${environment.apiUrl}/${endpoint}`;
    return this.http.post(url, data).pipe(
      catchError(this.handleError)
    );
  }

  mejorarDescripcion(text: string, systemInstruction?: string, model?: string, temperature?: number, usePayKey?: boolean, attempt?: number, totalAttempts?: number): Observable<any> {
    const url = `${environment.apiUrl}/api/pg/ia/mejorar-descripcion`;
    return this.http.post<any>(url, { text, systemInstruction, model, temperature, usePayKey, attempt, totalAttempts }).pipe(
      catchError(this.handleError)
    );
  }

  analizarFactura(base64Image: string, prompt?: string, systemInstruction?: string, model?: string, temperature?: number, usePayKey?: boolean, attempt?: number, totalAttempts?: number): Observable<any> {
    const url = `${environment.apiUrl}/api/pg/ia/analizar-factura`;
    return this.http.post<any>(url, { base64Image, prompt, systemInstruction, model, temperature, usePayKey, attempt, totalAttempts }).pipe(
      catchError(this.handleError)
    );
  }

  generarAnalisisIa(
    prompt: string, 
    options?: { model?: string; systemInstruction?: string; temperature?: number; usePayKey?: boolean; attempt?: number; totalAttempts?: number }
  ): Observable<any> {
    const url = `${environment.apiUrl}/${this.namespacecm}/ia/generar-analisis`;
    const payload = {
      prompt,
      model: options?.model || 'gemini-3.6-flash',
      systemInstruction: options?.systemInstruction,
      temperature: options?.temperature,
      usePayKey: options?.usePayKey || false,
      attempt: options?.attempt,
      totalAttempts: options?.totalAttempts
    };
    return this.http.post<any>(url, payload).pipe(
      catchError(this.handleError)
    );
  }

  getJsonParam(paramName: string): Observable<any> {
    const isSpecialAjustes = false; // Ya no usamos lógica especial para templates
    const url = isSpecialAjustes ? `${this.apiCommonGet}/datogenmodel` : `${this.apiCommonAjustes}/parametros/crud`;

    let subrutina = "SELECT_ONE";

    const payload = {
      rutina: isSpecialAjustes ? "ajustes" : "parametros",
      subrutina: subrutina,
      usuario: "system",
      datos: { dt1: "", dt2: paramName, dt3: "", dt4: "", dt5: "", dt6: "", dt7: "", dt8: "", dt9: "", dt10: "", dt11: "", dt12: "", dt13: "", dt14: "", dt15: "" }
    };

    return this.http.post<any>(url, payload).pipe(
      map(res => {
        // If it's a list (like SELECT_OBS_TEMPLATES), return the first item in the simplified format
        if (Array.isArray(res)) {
          if (res.length > 0) {
            const row = res[0];
            return {
              id: row.dt1 || row.id,
              pa_nombre: row.dt2 || row.pa_nombre,
              pa_json: row.dt3 || row.pa_json,
              fecha_creacion: row.dt4 || row.fecha_creacion
            };
          }
          return null;
        }
        return res; // Already an object (SELECT_ONE)
      }),
      catchError(this.handleError)
    );
  }

  saveJsonParam(paramName: string, jsonString: string): Observable<any> {
    const isSpecialAjustes = false;
    const url = isSpecialAjustes ? `${this.apiCommonGet}/datogenmodel` : `${this.apiCommonAjustes}/parametros/crud`;

    let subrutina = "UPDATE";

    const payload = {
      empresa: "pgarcia2",
      rutina: isSpecialAjustes ? "ajustes" : "parametros",
      subrutina: subrutina,
      usuario: "system",
      datos: {
        dt1: "",
        dt2: paramName,
        dt3: isSpecialAjustes ? "" : jsonString, // Generic UPDATE uses dt3
        dt4: "", dt5: "", dt6: "", dt7: "", dt8: "", dt9: "", dt10: "", dt11: "", dt12: "",
        dt13: isSpecialAjustes ? jsonString : "", // OBS uses dt13 (spr13)
        dt14: "", dt15: ""
      }
    };

    return this.http.post<any>(url, payload).pipe(
      catchError(this.handleError)
    );
  }

  namespacepg: string = "api/pg";
  namespacecm: string = "api/common";

  private apiCommonGet = `${environment.apiUrl}/${this.namespacecm}/consultas`
  private apiCommonAjustes = `${environment.apiUrl}/${this.namespacecm}/ajustes`
  private apiPgTrabajos = `${environment.apiUrl}/${this.namespacepg}/trabajos`
  private apiPgCotizaciones = `${environment.apiUrl}/${this.namespacepg}/cotizaciones`
  private apiPgInspecciones = `${environment.apiUrl}/${this.namespacepg}/inspecciones`
  private apiPgProcesos = `${environment.apiUrl}/${this.namespacepg}/procesos`
  private apiPgFacturas = `${environment.apiUrl}/${this.namespacepg}/facturas`;
  private apiPgAdmin = `${environment.apiUrl}/${this.namespacepg}/admin`;
  public apiPgCorreos = `${environment.apiUrl}/${this.namespacepg}/correos`;

  getCommonModel(json: Modelogeneral): Observable<Modelogeneraldatos[]> {
    const url = `${this.apiCommonGet}/datogenmodel`;
    return this.http.post<Modelogeneraldatos[]>(url, json).pipe(
      catchError(this.handleError)
    );
  }

  getOcModel(json: Modelogeneral): Observable<Modelogeneraldatos[]> {
    const url = `${this.apiPgProcesos}/oc_data`;
    return this.http.post<Modelogeneraldatos[]>(url, json).pipe(
      catchError(this.handleError)
    );
  }

  getCommonStr(json: Modelogeneral): Observable<string> {
    const url = `${this.apiCommonGet}/datogenstr`;
    return this.http.post(url, json, { responseType: 'text' }).pipe(
      catchError(this.handleError)
    );
  }

  LoginApp(json: Modelogeneral): Observable<Login> {
    const url = `${this.apiCommonGet}/login`;
    return this.http.post<Login>(url, json).pipe(
      map(response => {
        if (response.l_jmenu && typeof response.l_jmenu === 'string') {
          try {
            response.l_jmenu = JSON.parse(response.l_jmenu);
          } catch (e) {
            console.error('Error parsing menu JSON in service', e);
          }
        }
        return response;
      }),
      catchError(this.handleError)
    );
  }

  getImagenes(imagenes: string[], path: string): Observable<string[]> {
    const url = `${this.apiCommonGet}/getImages`;
    const json = { imagenes, path };
    return this.http.post<string[]>(url, json).pipe(
      catchError(this.handleError)
    );
  }

  getCommonList(json: any): Observable<string[]> {
    const url = `${this.apiCommonGet}/datogenlist`;
    return this.http.post<string[]>(url, json).pipe(
      catchError(this.handleError)
    );
  }

  registraDevice(json: any): Observable<boolean> {
    const url = `${this.apiCommonGet}/registraDevice`;
    return this.http.post<boolean>(url, json).pipe(
      catchError(this.handleError)
    );
  }

  validaDevice(json: any): Observable<Login> {
    const url = `${this.apiCommonGet}/validaDevice`;
    return this.http.post<Login>(url, json).pipe(
      catchError(this.handleError)
    );
  }

  insertaTrabajo(json: any): Observable<any> {
    const url = `${this.apiPgTrabajos}/inserta`;
    return this.http.post<any>(url, json).pipe(
      catchError(this.handleError)
    );
  }

  insertaCotizacion(json: any): Observable<any> {
    const url = `${this.apiPgCotizaciones}/inserta`;
    return this.http.post<any>(url, json).pipe(
      catchError(this.handleError)
    );
  }

  eliminaCotizacion(json: any): Observable<any> {
    const url = `${this.apiPgCotizaciones}/elimina`;
    return this.http.post<any>(url, json).pipe(
      catchError(this.handleError)
    );
  }

  getFileUrl(type: 'COT' | 'FAC' | 'ARS' | 'GAS' | 'OC' | 'INF' | 'ITF', id: number | string, download: boolean = false): string {
    const cb = new Date().getTime();
    return `${this.apiPgTrabajos}/file/get/${type}/${id}?download=${download}&empresa=${this.appId}&cb=${cb}`;
  }

  getFacturaFileUrl(filename: string): string {
    const cb = new Date().getTime();
    return `${environment.apiUrl}/api/pg/facturas/file/get/${filename}?empresa=${this.appId}&cb=${cb}`;
  }

  generarInformeFotografico(payload: any): Observable<any> {
    return this.genericPost('api/pg/trabajos/informe-fotografico/generar', payload);
  }

  savePresupuesto(json: any): Observable<any> {
    const url = `${this.apiPgTrabajos}/presupuesto/save`;
    return this.http.post<any>(url, json).pipe(
      catchError(this.handleError)
    );
  }

  savePresupuestoDetalle(json: any): Observable<any> {
    const url = `${this.apiPgTrabajos}/presupuesto/save/detalle`;
    return this.http.post<any>(url, json).pipe(
      catchError(this.handleError)
    );
  }

  getImage(filename: string, configKey: string = 'path_img_medidas'): Observable<string> {
    const url = `${this.apiPgTrabajos}/get-image`;
    const json = {
      usuario: 'system',
      datos: { dt1: filename, dt2: configKey }
    };
    return this.http.post(url, json, { responseType: 'text' }).pipe(
      catchError(this.handleError)
    );
  }

  convertPdfToImages(trabajoId: number, usuario: string): Observable<any> {
    const url = `${this.apiPgTrabajos}/ars/pdf-to-images`;
    const json = {
      usuario: usuario,
      datos: { dt1: String(trabajoId) }
    };
    return this.http.post<any>(url, json).pipe(
      catchError(this.handleError)
    );
  }

  getMedidaMetadata(filename: string): Observable<string> {
    const url = `${this.apiPgTrabajos}/presupuesto/medida/metadata`;
    // We send filename as ID (dt1) because backend logic expects ID but works with filename if consistent
    // Actually backend expects ID (Dt1). 
    // Wait, backend logic: String medidaId = request.getDatos().getDt1(); metadata_ + medidaId + .json
    // If frontend sends filename "medida_123_uuid.jpg", backend logic "metadata_medida_123_uuid.jpg.json" is weird.
    // Backend expects Medida ID (the database primary key).
    // I need to ensure frontend passes the ID.
    // Let's assume dt1 is the ID.
    const json = {
      datos: { dt1: filename }
    };
    return this.http.post(url, json, { responseType: 'text' }).pipe(
      catchError(this.handleError)
    );
  }

  // Accesos / Settings Endpoints
  getConfigMenu(): Observable<any> {
    const url = `${this.apiCommonAjustes}/parametros/crud`;
    let currentUser = "";
    const userJson = localStorage.getItem('user');
    if (userJson) {
      currentUser = JSON.parse(userJson).l_usuario || "";
    }
    const payload = {
      empresa: "pgarcia2",
      rutina: "parametros",
      subrutina: "SELECT_ONE",
      usuario: currentUser,
      datos: {
        dt1: "", dt2: "config_menu", dt3: "", dt4: "", dt5: "", dt6: "", dt7: "", dt8: "", dt9: "", dt10: "",
        dt11: "", dt12: "", dt13: "", dt14: "", dt15: ""
      }
    };
    return this.http.post<any>(url, payload).pipe(
      catchError(this.handleError)
    );
  }

  getUsuariosList(): Observable<any> {
    const url = `${this.apiCommonAjustes}/usuarios/crud`;
    let currentUser = "";
    const userJson = localStorage.getItem('user');
    if (userJson) {
      currentUser = JSON.parse(userJson).l_usuario || "";
    }
    const payload = {
      empresa: "pgarcia2",
      rutina: "usuarios",
      subrutina: "SELECT_ALL",
      usuario: currentUser,
      datos: {
        dt1: "", dt2: "", dt3: "", dt4: "", dt5: "", dt6: "", dt7: "", dt8: "", dt9: "", dt10: "",
        dt11: "", dt12: "", dt13: "", dt14: "", dt15: ""
      }
    };
    return this.http.post<any>(url, payload).pipe(
      catchError(this.handleError)
    );
  }

  saveUsuario(json: any): Observable<any> {
    const url = `${this.apiCommonAjustes}/usuarios/crud`;

    // Ensure the incoming payload has the correct empresa if it does not
    if (json && !json.empresa) {
      json.empresa = "pgarcia2";
    }

    return this.http.post<any>(url, json).pipe(
      catchError(this.handleError)
    );
  }
  saveTrabajoItemDetalle(json: any): Observable<any> {
    const url = `${this.apiPgTrabajos}/presupuesto/save/itemDetalle`;
    return this.http.post<any>(url, json).pipe(
      catchError(this.handleError)
    );
  }

  saveTrabajoGaleriaArchivo(json: any): Observable<any> {
    const url = `${this.apiPgTrabajos}/galeria/save`;
    return this.http.post<any>(url, json).pipe(
      catchError(this.handleError)
    );
  }

  saveInspeccionDetalleArchivo(json: any): Observable<any> {
    const url = `${this.apiPgInspecciones}/save/detalleArchivo`;
    return this.http.post<any>(url, json).pipe(
      catchError(this.handleError)
    );
  }

  saveInspeccionMedida(json: any): Observable<any> {
    const url = `${this.apiPgInspecciones}/save/medida`;
    return this.http.post<any>(url, json).pipe(
      catchError(this.handleError)
    );
  }

  getInspeccionMedidaMetadata(filename: string): Observable<string> {
    const url = `${this.apiPgInspecciones}/medida/metadata`;
    const json = {
      datos: { dt1: filename }
    };
    return this.http.post(url, json, { responseType: 'text' }).pipe(
      catchError(this.handleError)
    );
  }


  saveInspeccionImagenNota(json: any): Observable<any> {
    const url = `${this.apiPgInspecciones}/save/imagenNota`;
    return this.http.post<any>(url, json).pipe(
      catchError(this.handleError)
    );
  }

  saveInspeccionEstimado(json: any): Observable<any> {
    const url = `${this.apiPgInspecciones}/save/estimado`;
    return this.http.post<any>(url, json).pipe(
      catchError(this.handleError)
    );
  }

  getInspeccionEstimadosList(areaId: string): Observable<Modelogeneraldatos[]> {
    const json: Modelogeneral = {
      empresa: "pgarcia2",
      rutina: "genModel",
      subrutina: "inspeccionEstimadosList",
      usuario: "system",
      datos: {
        dt1: areaId, dt2: "", dt3: "", dt4: "", dt5: "", dt6: "", dt7: "", dt8: "", dt9: "", dt10: "",
        dt11: "", dt12: "", dt13: "", dt14: "", dt15: ""
      }
    };
    return this.getCommonModel(json);
  }

  // --------------------------------------------------------------------------
  // PLANILLA / PAYROLL SERVICES
  // --------------------------------------------------------------------------

  saveTrabajador(json: any): Observable<any> {
    const url = `${this.apiPgTrabajos}/planilla/trabajadores/save`;
    return this.http.post<any>(url, json).pipe(
      catchError(this.handleError)
    );
  }

  savePlanillaActividad(json: any): Observable<any> {
    const url = `${this.apiPgTrabajos}/planilla/actividad/save`;
    return this.http.post<any>(url, json).pipe(
      catchError(this.handleError)
    );
  }

  getPlanillaActividad(trabajoId: string, fecha: string, usuario: string = 'system'): Observable<Modelogeneraldatos[]> {
    const url = `${this.apiPgTrabajos}/planilla/actividad/getByDate`;
    const json = {
      usuario: usuario,
      datos: {
        dt1: trabajoId,
        dt2: fecha
      }
    };
    return this.http.post<Modelogeneraldatos[]>(url, json).pipe(
      catchError(this.handleError)
    );
  }

  getTrabajadoresList(searchText: string = '', trabajoId: string | number = '', usuario: string = 'system'): Observable<Modelogeneraldatos[]> {
    const url = `${this.apiPgTrabajos}/planilla/trabajadores/list`;
    const json = {
      usuario: usuario,
      datos: {
        dt1: searchText,
        dt2: String(trabajoId || '')
      }
    };
    return this.http.post<Modelogeneraldatos[]>(url, json).pipe(
      catchError(this.handleError)
    );
  }

  // --------------------------------------------------------------------------
  // PLANILLA CALENDARIO
  // --------------------------------------------------------------------------

  /**
   * Obtiene los 7 días (Lun-Dom) de la semana que contiene la fecha dada.
   * Retorna: dt1=fecha, dt2=nombre_dia, dt3=total_trabajadores, dt4=total_pago, dt5=tiene_registros(Y/N)
   * @param fecha - Fecha en formato "YYYY-MM-DD"
   */
  getPlanillaCalendario(fecha: string, usuario: string = 'system'): Observable<Modelogeneraldatos[]> {
    const url = `${this.apiPgTrabajos}/planilla/calendario`;
    const json = {
      usuario: usuario,
      datos: { dt1: fecha }
    };
    return this.http.post<Modelogeneraldatos[]>(url, json).pipe(
      catchError(this.handleError)
    );
  }

  /**
   * Obtiene el detalle de planilla de un día específico agrupado por LUGAR o TRABAJADOR.
   * Retorna: dt1=nombre, dt2=cantidad_trabajadores, dt3=lista_asociados, dt4=total_pago, dt5=agrupacion
   * @param fecha - Fecha en formato "YYYY-MM-DD"
   * @param agrupacion - 'LUGAR' | 'TRABAJADOR'
   */
  getPlanillaCalendarioDetalle(fecha: string, agrupacion: 'LUGAR' | 'TRABAJADOR', usuario: string = 'system'): Observable<Modelogeneraldatos[]> {
    const url = `${this.apiPgTrabajos}/planilla/calendario/detalle`;
    const json = {
      usuario: usuario,
      datos: { dt1: fecha, dt2: agrupacion }
    };
    return this.http.post<Modelogeneraldatos[]>(url, json).pipe(
      catchError(this.handleError)
    );
  }

  /**
   * Obtiene el resumen semanal detallado de un trabajador específico.
   * @param fecha - Cualquier fecha de la semana (YYYY-MM-DD)
   * @param trabajador - Nombre del trabajador
   */
  getPlanillaCalendarioTrabajador(fecha: string, trabajador: string, usuario: string = 'system'): Observable<Modelogeneraldatos[]> {
    const url = `${this.apiPgTrabajos}/planilla/calendario/trabajador`;
    const json = {
      usuario: usuario,
      datos: { dt1: fecha, dt2: trabajador }
    };
    return this.http.post<Modelogeneraldatos[]>(url, json).pipe(
      catchError(this.handleError)
    );
  }

  private handleError(error: any) {
    console.error('API error:', error);
    return throwError(() => error);
  }


  getDiasTrabajados(trabajoId: string): Observable<string[]> {
    const url = `${this.apiPgTrabajos}/planilla/dias`;
    const params = new HttpParams().append("trabajoId", trabajoId);
    return this.http.get<string[]>(url, { params: params }).pipe(
      catchError(this.handleError)
    );
  }

  // --------------------------------------------------------------------------
  // GASTOS (EXPENSES) SERVICES
  // --------------------------------------------------------------------------

  saveGasto(json: any): Observable<any> {
    const url = `${this.apiPgTrabajos}/gastos/save`;
    return this.http.post<any>(url, json).pipe(
      catchError(this.handleError)
    );
  }

  deleteGasto(id: string, usuario: string = 'system'): Observable<any> {
    const url = `${this.apiPgTrabajos}/gastos/delete`;
    const json = {
      usuario: usuario,
      datos: { dt1: id }
    };
    return this.http.post<any>(url, json).pipe(
      catchError(this.handleError)
    );
  }

  getGastosList(trabajoId: string, usuario: string = 'system'): Observable<Modelogeneraldatos[]> {
    const url = `${this.apiPgTrabajos}/gastos/list`;
    const json = {
      usuario: usuario,
      datos: { dt1: trabajoId }
    };
    return this.http.post<Modelogeneraldatos[]>(url, json).pipe(
      catchError(this.handleError)
    );
  }

  vincularOc(json: any): Observable<any> {
    const url = `${this.apiPgProcesos}/vincular_oc`;
    return this.http.post<any>(url, json).pipe(
      catchError(this.handleError)
    );
  }

  uploadArsFile(trabajoId: number, filename: string, base64: string): Observable<any> {
    const url = `${this.apiPgTrabajos}/ars/upload`;
    const json = {
      usuario: 'system',
      datos: { dt1: String(trabajoId), dt2: filename, dt3: base64 }
    };
    return this.http.post<any>(url, json).pipe(
      catchError(this.handleError)
    );
  }

  executeAdminCrud(entity: string, subrutina: string, datos: any): Observable<any> {
    const url = `${this.apiPgAdmin}/execute`;
    let currentUser = "system";
    const userJson = localStorage.getItem('user');
    if (userJson) {
      currentUser = JSON.parse(userJson).l_usuario || "system";
    }
    const payload: any = {
      empresa: "pgarcia2",
      rutina: entity,
      subrutina: subrutina,
      usuario: currentUser,
      datos: datos
    };
    return this.http.post<any>(url, payload).pipe(
      catchError(this.handleError)
    );
  }

  getRolesApp(): Observable<any> {
    return this.executeAdminCrud('ROL_APP', 'SELECT_ALL', { dt1: '' });
  }

  saveRoleApp(subrutina: 'INSERT' | 'UPDATE' | 'DELETE', role: any): Observable<any> {
    return this.executeAdminCrud('ROL_APP', subrutina, role);
  }

  // --------------------------------------------------------------------------
  // FACTURAS IMAGES/FILES
  // --------------------------------------------------------------------------

  uploadFactura(base64: string, filename: string, usuario: string): Observable<any> {
    const url = `${this.apiPgFacturas}/upload`;
    const json = {
      usuario: usuario,
      datos: {
        dt1: base64,
        dt2: filename
      }
    };
    return this.http.post<any>(url, json).pipe(
      catchError(this.handleError)
    );
  }

  getFacturasList(usuario: string): Observable<any[]> {
    const url = `${this.apiPgFacturas}/list`;
    const json = {
      usuario: usuario
    };
    return this.http.post<any[]>(url, json).pipe(
      catchError(this.handleError)
    );
  }

  generarReporteFacturas(periodLabel: string, yearMonth: string, filenames: string[], usuario: string): Observable<any> {
    const url = `${this.apiPgFacturas}/generar-reporte`;
    const json = {
      usuario: usuario,
      datos: {
        dt1: periodLabel,
        dt2: yearMonth,
        dt3: filenames.join(',')
      }
    };
    return this.http.post<any>(url, json).pipe(
      catchError(this.handleError)
    );
  }

  generarReporteMensual(periodLabel: string, yearMonth: string, usuario: string): Observable<any> {
    const url = `${this.apiPgFacturas}/generar-reporte-mensual`;
    const json = {
      usuario: usuario,
      datos: {
        dt1: periodLabel,
        dt2: yearMonth
      }
    };
    return this.http.post<any>(url, json).pipe(
      catchError(this.handleError)
    );
  }

  deleteFactura(filename: string, usuario: string): Observable<any> {
    const url = `${this.apiPgFacturas}/delete`;
    const json = {
      usuario: usuario,
      datos: {
        dt1: filename
      }
    };
    return this.http.post<any>(url, json).pipe(
      catchError(this.handleError)
    );
  }

  updateFactura(filename: string, fecha: string, lugar: string, monto: string, usuario: string): Observable<any> {
    const url = `${this.apiPgFacturas}/update`;
    const json = {
      usuario: usuario,
      datos: {
        dt1: filename,
        dt2: fecha,
        dt3: lugar,
        dt4: monto
      }
    };
    return this.http.post<any>(url, json).pipe(
      catchError(this.handleError)
    );
  }

  overwriteFactura(base64: string, filename: string, usuario: string): Observable<any> {
    const url = `${this.apiPgFacturas}/overwrite`;
    const json = {
      usuario: usuario,
      datos: {
        dt1: base64,
        dt2: filename
      }
    };
    return this.http.post<any>(url, json).pipe(
      catchError(this.handleError)
    );
  }

  getTopSolicitantes(usuario: string): Observable<any[]> {
    const json = {
      empresa: this.appId || 'pgarcia',
      rutina: 'common_rq',
      subrutina: 'top_solicitantes',
      usuario: usuario,
      datos: {
        dt1: '', dt2: '', dt3: '', dt4: '', dt5: '', dt6: '', dt7: '', dt8: '', dt9: '', dt10: '', dt11: '', dt12: '', dt13: '', dt14: '', dt15: ''
      }
    };
    return this.getCommonModel(json);
  }

  getTopDirecciones(clienteId: number, usuario: string): Observable<any[]> {
    const json = {
      empresa: this.appId || 'pgarcia',
      rutina: 'common_rq',
      subrutina: 'top_direcciones',
      usuario: usuario,
      datos: {
        dt1: String(clienteId), dt2: '', dt3: '', dt4: '', dt5: '', dt6: '', dt7: '', dt8: '', dt9: '', dt10: '', dt11: '', dt12: '', dt13: '', dt14: '', dt15: ''
      }
    };
    return this.getCommonModel(json);
  }
}